var React = require('react');

function NetBank (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"download-file","d":"M15,8h4.4L14,2.6V7A.945.945,0,0,0,15,8Zm6.7,10.3h0a.967.967,0,0,0-1.4,0l-.3.3V16a1,1,0,0,0-2,0v2.6l-.3-.3a.99.99,0,0,0-1.4,1.4l2,2a.967.967,0,0,0,1.4,0h0l2-2A.967.967,0,0,0,21.7,18.3Zm-6.5-1.1a2.729,2.729,0,0,1,1.3-.7V16A2.476,2.476,0,0,1,19,13.5a3.553,3.553,0,0,1,1,.2V10H15a2.946,2.946,0,0,1-3-3V2H7A2.946,2.946,0,0,0,4,5V19a2.946,2.946,0,0,0,3,3h9.5l-1.2-1.2A2.632,2.632,0,0,1,15.2,17.2ZM9,8h1a.945.945,0,0,1,1,1,.945.945,0,0,1-1,1H9A.945.945,0,0,1,8,9,.945.945,0,0,1,9,8Zm2,10H9a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2ZM9,14a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z","transform":"translate(-4 -2)","fill":"#2425aa"}));
}

NetBank.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20"};

module.exports = NetBank;

NetBank.default = NetBank;
